/* IvitaPure — Crealyte PDP (cpdp): sticky CTA (mobil), cart attribute "Nivå"
   och Klaviyo-händelser. Spec §13 + byggnoterna om Klaviyo.

   Idempotent: laddas både av sticky-sektionen och av prisstegs-snippeten, så att
   nivån hamnar på varukorgen även utan sticky-raden. Anropar ALDRIG
   preventDefault på köpformuläret: AJAX-varukorgen i ivitapure-cpdp.js äger
   submit, det här skriptet bara läser och kompletterar. */
(function () {
  if (window.__cpdpSticky) return;
  window.__cpdpSticky = true;

  var ATTR_KEY = 'Nivå';
  var ANON_KEY = 'ip_quiz_anon';   /* samma anonyma id som quizet: en anonym profil per webbläsare */
  var KX_KEY = 'ip_kl_kx';          /* Klaviyos utbytes-id från en klickad e-postlänk */

  function toArr(list) { return Array.prototype.slice.call(list || []); }
  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  function clean(t) { return String(t == null ? '' : t).replace(/ /g, ' ').trim(); }
  function toNum(v) { var n = Number(v); return v !== '' && v != null && isFinite(n) ? n : null; }
  function cartRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* ---------- 1 · Prisstegen: vald nivå och lägsta dagspris ---------- */
  function radiosOf(form) { return toArr(form.querySelectorAll('.cpdp-tier-radio')); }

  /* Samma regel som köpboxens skript: vald och köpbar, annars första köpbara. */
  function pickedRadio(form) {
    var rs = radiosOf(form);
    return rs.filter(function (r) { return r.checked && !r.disabled; })[0] ||
           rs.filter(function (r) { return !r.disabled; })[0] || null;
  }

  /* En nivå som inte går att köpa: slutsåld (disabled) eller spärrad för att
     säljplanen eller SKU:n saknas (data-plan-missing, se ivitapure-cpdp.js). */
  function isLocked(r) {
    return !!(r.disabled || r.getAttribute('data-plan-missing') === 'true');
  }

  /* Låsta nivåer räknas aldrig: "Från X per dag" ska gå att köpa. */
  function lowestPerDay(form) {
    var best = null;
    radiosOf(form).forEach(function (r) {
      if (isLocked(r)) return;
      var cents = parseInt(r.getAttribute('data-perday-cents'), 10);
      var label = r.getAttribute('data-perday');
      if (!isFinite(cents) || cents <= 0 || !label) return;
      if (!best || cents < best.cents) best = { cents: cents, label: label };
    });
    return best;
  }

  /* Köpraden kan visa något annat än dagspriset stort. Prisstegens fieldset bär då
     data-price-emphasis, och köpraden visar det stora talet med dagspriset litet efter:

       "total"  priset per leverans   (köpblockets price_emphasis = total)
       "manad"  samma tal som nivåkortet visar stort, alltså pris per månad på en
                prenumeration och hela priset på ett engångsköp
                (köpblockets sticky_price = card)

     Utan attributet gäller allt som förut: dagspriset stort, ensamt. */
  function prisLage(form) {
    var fs = form ? form.querySelector('.cpdp-tiers[data-price-emphasis]') : null;
    var v = fs ? fs.getAttribute('data-price-emphasis') : '';
    return (v === 'total' || v === 'manad') ? v : '';
  }

  /* Attributparet som bär det stora talet i respektive läge. */
  function storaAttr(lage) {
    return lage === 'manad'
      ? { label: 'data-permonth', cents: 'data-permonth-cents', suffix: 'data-permonth-suffix' }
      : { label: 'data-price', cents: 'data-price-cents', suffix: null };
  }

  /* Samma regel som lowestPerDay, men för det stora talet i lägena ovan. */
  function lowestStora(form, lage) {
    var a = storaAttr(lage);
    var best = null;
    radiosOf(form).forEach(function (r) {
      if (isLocked(r)) return;
      var cents = parseInt(r.getAttribute(a.cents), 10);
      var label = r.getAttribute(a.label);
      if (!isFinite(cents) || cents <= 0 || !label) return;
      if (!best || cents < best.cents) best = { cents: cents, label: label, radio: r };
    });
    return best;
  }

  function syncTierAttr(form) {
    var input = form.querySelector('[data-cpdp-tier-attr]');
    if (!input) return;
    var r = pickedRadio(form);
    input.value = r ? clean(r.getAttribute('data-tier-name')) : '';
  }

  function bindForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    toArr(scope.querySelectorAll('form[data-cpdp-form]')).forEach(syncTierAttr);
  }

  /* Delegerat: fungerar även när köpblocket laddas om i temaredigeraren.
     Byter kunden nivå ska den klibbiga raden följa med — annars står engångsköpets
     dagspris kvar medan hon valt 90 dagar. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.cpdp-tier-radio')) return;
    var form = t.form || t.closest('form[data-cpdp-form]');
    if (form) syncTierAttr(form);
    stickies.forEach(function (st) { if (st.refreshPrice) st.refreshPrice(); });
  });

  function findForm(targetId) {
    var t = targetId ? document.getElementById(targetId) : null;
    var f = null;
    if (t) f = t.matches('form[data-cpdp-form]') ? t : t.querySelector('form[data-cpdp-form]');
    return f || document.querySelector('form[data-cpdp-form]');
  }

  /* ---------- 2 · Sticky-raden ---------- */
  var stickies = [];

  function headerOffset() {
    var h = document.querySelector('.site-header');
    if (!h) return 96;
    var pos = window.getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 16;
    return Math.round(h.getBoundingClientRect().height) + 16;
  }

  /* Underkant på ett fast sidhuvud: ett formulär som ligger bakom sidhuvudet
     syns inte, så det räknas som förbiscrollat. */
  function headerBottom() {
    var h = document.querySelector('.site-header');
    if (!h) return 0;
    var pos = window.getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
  }

  function initSticky(root) {
    if (!root || root.__cpdpStickyBound) return;
    var bar = root.querySelector('[data-cpdp-sticky-bar]');
    if (!bar) return;
    root.__cpdpStickyBound = true;

    var go = root.querySelector('[data-cpdp-sticky-go]');
    var add = root.querySelector('[data-cpdp-sticky-add]');
    var priceWrap = root.querySelector('[data-cpdp-sticky-price]');
    var priceNum = root.querySelector('[data-cpdp-sticky-perday]');
    var pre = root.querySelector('[data-cpdp-sticky-pre]');
    var suf = root.querySelector('.cpdp-sticky-suf');
    var sufRaw = suf ? suf.textContent : '';            /* sektionens "per dag", som den står i HTML:en */
    var sufText = clean(sufRaw);
    var targetId = root.getAttribute('data-target') || 'kop';
    var st = { root: root, form: null, formPast: false, footerIn: false, forced: false, observers: [], raf: 0, sufTouched: false };

    st.render = function () {
      bar.classList.toggle('is-shown', st.forced || (st.formPast && !st.footerIn));
    };

    /* Läget räknas alltid ur formulärets faktiska position. */
    st.check = function () {
      var f = st.form;
      st.formPast = !!(f && document.documentElement.contains(f) &&
        f.getBoundingClientRect().bottom <= headerBottom());
      st.render();
    };
    st.onScroll = function () {
      if (st.raf) return;
      st.raf = window.requestAnimationFrame(function () { st.raf = 0; st.check(); });
    };

    /* Raden speglar den nivå kunden valt: väljer hon 90 dagar ska det stå 13,30 kr
       per dag, inte engångsköpets dagspris. Först när den valda nivån saknar
       dagspris faller raden tillbaka på det lägsta köpbara, och då — och bara då —
       står ordet "Från" framför. */
    st.refreshPrice = function () {
      if (!priceWrap || !priceNum) return;
      var form = findForm(targetId);
      var vald = form ? pickedRadio(form) : null;

      /* Något annat än dagspriset stort: "249 kr" eller "399 kr/mån" stort och
         "13,30 kr per dag" litet efter. Ordet "per dag" är sektionens egen text och
         följer nu dagspriset i stället för det stora talet. Saknar nivån dagspris
         står det stora priset ensamt. */
      var lage = prisLage(form);
      if (lage) {
        var attr = storaAttr(lage);
        var tLabel = vald ? vald.getAttribute(attr.label) : null;
        var tCents = vald ? parseInt(vald.getAttribute(attr.cents), 10) : NaN;
        var kalla = null;
        var tFran = false;
        if (tLabel && isFinite(tCents) && tCents > 0) {
          kalla = vald;
        } else {
          var lagst = lowestStora(form, lage);
          if (lagst) { tLabel = lagst.label; kalla = lagst.radio; tFran = true; }
          else tLabel = null;
        }
        /* Prenumerationens "/mån" hänger på talet, som i nivåkortet. */
        if (tLabel && attr.suffix && kalla) {
          var sfx = clean(kalla.getAttribute(attr.suffix) || '');
          if (sfx) tLabel = tLabel + sfx;
        }
        priceNum.textContent = tLabel || '';
        priceWrap.hidden = !tLabel;
        if (pre) pre.hidden = !tFran;
        if (suf) {
          var dag = kalla ? kalla.getAttribute('data-perday') : '';
          var dagCents = kalla ? parseInt(kalla.getAttribute('data-perday-cents'), 10) : NaN;
          var visaDag = !!(dag && isFinite(dagCents) && dagCents > 0 && sufText);
          suf.textContent = visaDag ? dag + ' ' + sufText : '';
          suf.hidden = !visaDag;
          st.sufTouched = true;
        }
        return;
      }

      /* Har ett sådant läge skrivit om "per dag" (köpblocket bytte läge i temaredigeraren
         utan att köpraden laddades om): skriv tillbaka sektionens egen text. En sida som
         aldrig varit i ett sådant läge rör aldrig suffixet. */
      if (suf && st.sufTouched) {
        suf.textContent = sufRaw;
        suf.hidden = false;
        st.sufTouched = false;
      }

      var valdLabel = vald ? vald.getAttribute('data-perday') : null;
      var valdCents = vald ? parseInt(vald.getAttribute('data-perday-cents'), 10) : NaN;
      var visa = null;
      var franLage = false;

      if (valdLabel && isFinite(valdCents) && valdCents > 0) {
        visa = valdLabel;
      } else {
        var best = form ? lowestPerDay(form) : null;
        if (best) { visa = best.label; franLage = true; }
      }

      priceNum.textContent = visa || '';
      priceWrap.hidden = !visa;
      if (pre) pre.hidden = !franLage;
    };

    st.disconnect = function () {
      st.observers.forEach(function (o) { o.disconnect(); });
      st.observers = [];
      window.removeEventListener('scroll', st.onScroll);
      window.removeEventListener('resize', st.onScroll);
      if (st.raf) { window.cancelAnimationFrame(st.raf); st.raf = 0; }
    };

    /* Visas när formuläret ligger ovanför skärmen, döljs när det syns igen.
       Sidfoten döljer också raden, så att den aldrig täcker sidfotens länkar. */
    st.observe = function () {
      st.disconnect();
      st.formPast = false;
      st.footerIn = false;
      st.form = findForm(targetId);
      if (!st.form) { st.render(); return; }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function () { st.check(); });
        io.observe(st.form);
        st.observers.push(io);

        var foot = document.querySelector('.shopify-section-group-footer-group, .site-footer');
        if (foot) {
          var io2 = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { st.footerIn = en.isIntersecting; });
            st.render();
          });
          io2.observe(foot);
          st.observers.push(io2);
        }
      }

      /* IntersectionObserver meddelar bara när formuläret korsar skärmkanten.
         Ett hopp förbi det (ankarlänk, återställd scrollposition efter
         bakåtknappen) ger ingen notis, därför kontrolleras läget även vid
         scroll, högst en gång per bildruta. */
      window.addEventListener('scroll', st.onScroll, { passive: true });
      window.addEventListener('resize', st.onScroll, { passive: true });
      st.check();
    };

    /* Knappen lägger i varukorgen direkt (sektionens cta_action = add). Den trycker på
       köpblockets egen knapp i stället för att bygga en egen väg till varukorgen, så
       allt som hänger på den följer med: vald nivå, säljplan, antal, gåvorna och
       spärren för en nivå som saknar plan eller SKU. Går knappen inte att trycka på
       skrollar vi till prisstegen i stället, så klicket aldrig blir tomt. */
    if (add) add.addEventListener('click', function (ev) {
      ev.preventDefault();
      var form = findForm(targetId);
      var btn = form ? form.querySelector('[data-cpdp-submit]') : null;
      if (btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') { btn.click(); return; }
      var fs = form ? form.querySelector('fieldset.cpdp-tiers') : null;
      var mal = fs || document.getElementById(targetId);
      if (!mal) return;
      mal.style.scrollMarginTop = headerOffset() + 'px';
      try { mal.scrollIntoView({ behavior: mq('(prefers-reduced-motion: reduce)') ? 'auto' : 'smooth', block: 'start' }); }
      catch (e) { mal.scrollIntoView(true); }
    });

    if (go) go.addEventListener('click', function (ev) {
      var form = findForm(targetId);
      var fieldset = form ? form.querySelector('fieldset.cpdp-tiers') || form.querySelector('fieldset') : null;
      var dest = fieldset || document.getElementById(targetId);
      if (!dest) return;                       /* ingen köpbox: länken hoppar som vanligt */
      ev.preventDefault();
      dest.style.scrollMarginTop = headerOffset() + 'px';
      var smooth = !mq('(prefers-reduced-motion: reduce)');
      try { dest.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' }); }
      catch (e) { dest.scrollIntoView(true); }
      if (fieldset) {
        if (!fieldset.hasAttribute('tabindex')) fieldset.setAttribute('tabindex', '-1');
        try { fieldset.focus({ preventScroll: true }); } catch (e) { fieldset.focus(); }
      }
    });

    stickies.push(st);
    st.refreshPrice();
    st.observe();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    bindForms(scope);
    toArr(scope.querySelectorAll('[data-cpdp-sticky]')).forEach(initSticky);
    if (scope.matches && scope.matches('[data-cpdp-sticky]')) initSticky(scope);
  }

  /* ---------- 3 · Klaviyo ---------- */
  function readConfig() {
    var el = document.querySelector('[data-cpdp-sticky-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  /* Klaviyos onsite-skript (app-inbäddningen) om det finns på sidan. */
  function onsiteTracker() {
    var k = window.klaviyo;
    if (k && typeof k.push === 'function') return function (n, p) { k.push(['track', n, p]); };
    var lq = window._learnq;
    if (lq && typeof lq.push === 'function') return function (n, p) { lq.push(['track', n, p]); };
    return null;
  }
  function hasOnsite() {
    return !!(onsiteTracker() || document.querySelector('script[src*="static.klaviyo.com/onsite"], script[src*="klaviyo.js"]'));
  }

  function readKlaCookie() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      return m ? JSON.parse(window.atob(decodeURIComponent(m[1]))) : null;
    } catch (e) { return null; }
  }

  /* Vem händelsen gäller: Klaviyos utbytes-id om besökaren kommit från ett
     Klaviyo-mejl, annars ett anonymt id. Inga personuppgifter skickas härifrån. */
  function identity() {
    try {
      var kx = new URLSearchParams(window.location.search).get('_kx');
      if (kx) {
        try { localStorage.setItem(KX_KEY, kx); } catch (e) {}
        return { _kx: kx };
      }
    } catch (e) {}
    var c = readKlaCookie();
    if (c && c.$exchange_id) return { _kx: c.$exchange_id };
    try {
      var saved = localStorage.getItem(KX_KEY);
      if (saved) return { _kx: saved };
      var anon = localStorage.getItem(ANON_KEY);
      if (!anon) {
        anon = 'ip-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        localStorage.setItem(ANON_KEY, anon);
      }
      return { anonymous_id: anon };
    } catch (e) { return null; }
  }

  function consentNow() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return null;
    try {
      if (typeof cp.marketingAllowed === 'function') return !!cp.marketingAllowed();
      if (typeof cp.userCanBeTracked === 'function') return !!cp.userCanBeTracked();
    } catch (e) {}
    return null;
  }

  var consentLoading = false;
  function loadConsentApi(done) {
    if (window.Shopify && window.Shopify.customerPrivacy) { done(); return; }
    if (!(window.Shopify && typeof window.Shopify.loadFeatures === 'function') || consentLoading === 'failed') { done(); return; }
    consentLoading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) consentLoading = 'failed';
        done();
      });
    } catch (e) { consentLoading = 'failed'; done(); }
  }

  /* Samma villkor som Klaviyos egen pixel: skicka när marknadsföring är tillåten.
     Nekat nu men samtycke ges senare: skicka då. Inget samtyckes-API: skicka. */
  function whenAllowed(cfg, cb) {
    if (!cfg.consent) { cb(); return; }
    loadConsentApi(function () {
      var ok = consentNow();
      if (ok !== false) { cb(); return; }
      document.addEventListener('visitorConsentCollected', function once() {
        document.removeEventListener('visitorConsentCollected', once);
        if (consentNow() !== false) cb();
      });
    });
  }

  function send(cfg, name, props, value, keepalive) {
    if (!cfg || !cfg.company || !name) return;
    whenAllowed(cfg, function () {
      var track = onsiteTracker();
      if (track) {
        if (typeof value === 'number' && isFinite(value)) props.$value = value;
        try { track(name, props); } catch (e) {}
        return;
      }
      var who = identity();
      if (!who || !window.fetch) return;
      var attrs = {
        properties: props,
        metric: { data: { type: 'metric', attributes: { name: name } } },
        profile: { data: { type: 'profile', attributes: who } }
      };
      if (typeof value === 'number' && isFinite(value)) attrs.value = value;
      var opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: attrs } })
      };
      if (keepalive) opts.keepalive = true;
      try { fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(cfg.company), opts).catch(function () {}); }
      catch (e) {}
    });
  }

  function viewedProduct() {
    var cfg = readConfig();
    if (!cfg || !cfg.company || !cfg.product || cfg.viewedProduct === 'off') return;
    if (cfg.viewedProduct !== 'always' && hasOnsite()) return;   /* onsite-skriptet spårar själv */
    if (window.__cpdpViewedSent) return;
    window.__cpdpViewedSent = true;
    var p = cfg.product;
    send(cfg, 'Viewed Product', {
      ProductName: p.ProductName,
      ProductID: p.ProductID,
      SKU: p.SKU,
      Categories: p.Categories || [],
      ImageURL: p.ImageURL,
      URL: p.URL,
      Brand: p.Brand,
      Price: p.Price,
      CompareAtPrice: p.CompareAtPrice
    }, p.Price, false);
  }

  /* ---------- 4 · Köp: nivån till varukorgen och till Klaviyo ---------- */

  /* Säkerhetsnät för cart attribute. Fältet attributes[Nivå] följer med formuläret,
     men Shopifys dokumentation för /cart/add.js nämner inte attribut. Därför
     kontrolleras varukorgen när tillägget är klart (händelsen cpdp:cart-added,
     som bara skickas efter ett lyckat /cart/add.js), och nivån skrivs med
     /cart/update.js om den saknas. Körs efter tillägget, aldrig parallellt,
     så att en ny varukorg inte kan skapas två gånger, och aldrig för ett köp
     som stoppats: då skulle en nivå som inte lagts i varukorgen skrivas över
     den som finns där. */
  function ensureCartAttr(value) {
    if (!value || !window.fetch) return;
    var root = cartRoot();
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        if (cart.attributes && cart.attributes[ATTR_KEY] === value) return;
        var fd = new FormData();
        fd.append('attributes[' + ATTR_KEY + ']', value);
        return fetch(root + 'cart/update.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
      })
      .catch(function () {});
  }

  function sendAddEvent(r, keepalive) {
    var cfg = readConfig();
    if (!cfg || !cfg.company || !cfg.addEvent) return;
    var tier = clean(r.getAttribute('data-tier-name'));
    var plan = r.getAttribute('data-plan') || '';
    var priceCents = parseInt(r.getAttribute('data-price-cents'), 10);
    var perDayCents = parseInt(r.getAttribute('data-perday-cents'), 10);
    var price = isFinite(priceCents) ? priceCents / 100 : null;
    var p = cfg.product || {};
    send(cfg, cfg.addEvent, {
      'Nivå': tier,
      VariantID: toNum(r.getAttribute('data-variant')),
      SellingPlanID: plan ? toNum(plan) : null,
      Prenumeration: !!plan,
      Pris: price,
      PrisText: clean(r.getAttribute('data-price')),
      PrisPerDag: isFinite(perDayCents) ? perDayCents / 100 : null,
      SKU: r.getAttribute('data-sku') || '',
      ProductName: p.ProductName || '',
      ProductID: p.ProductID || null,
      URL: p.URL || ''
    }, price, keepalive);
  }

  function hasAjaxCart() {
    var drawer = document.querySelector('cart-drawer');
    return !!(drawer && typeof drawer.renderContents === 'function');
  }

  /* Fångstfas: körs före varukorgsskriptets lyssnare, så att fältet har rätt
     värde när formuläret läses. Ingen preventDefault.
     Fångstfasen körs också FÖRE köpspärren i ivitapure-cpdp.js, därför skickas
     inget härifrån för en spärrad nivå. Med varukorgslåda väntar Klaviyo-
     händelsen på cpdp:cart-added (varan finns verkligen i varukorgen). Utan
     låda lämnar sidan direkt med en vanlig POST: då skickas händelsen nu, med
     keepalive. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-cpdp-form]')) return;
    syncTierAttr(form);
    var r = pickedRadio(form);
    form.__cpdpPendingTier = null;
    if (!r) return;
    if (r.getAttribute('data-plan-missing') === 'true') return;   /* stoppas av köpspärren */

    if (hasAjaxCart()) {
      form.__cpdpPendingTier = r;
      return;
    }
    sendAddEvent(r, true);
  }, true);

  /* Skickas av ivitapure-cpdp.js när /cart/add.js har lyckats. */
  document.addEventListener('cpdp:cart-added', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-cpdp-form]')) return;
    var r = form.__cpdpPendingTier || pickedRadio(form);
    form.__cpdpPendingTier = null;
    if (!r || r.getAttribute('data-plan-missing') === 'true') return;
    if (form.querySelector('[data-cpdp-tier-attr]')) ensureCartAttr(clean(r.getAttribute('data-tier-name')));
    sendAddEvent(r, true);                      /* keepalive: sidan kan gå vidare till varukorgen */
  });

  /* ---------- 5 · Start och temaredigeraren ---------- */
  function boot() {
    initAll(document);
    var cfg = readConfig();
    if (cfg && cfg.company && cfg.consent) loadConsentApi(function () {});
    if (document.readyState === 'complete') setTimeout(viewedProduct, 0);
    else window.addEventListener('load', viewedProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    stickies.forEach(function (st) { st.refreshPrice(); st.observe(); });
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var t = e.target;
    stickies = stickies.filter(function (st) {
      if (t && t.contains && t.contains(st.root)) { st.disconnect(); return false; }
      return true;
    });
  });
  function setForced(e, on) {
    var id = e.detail && e.detail.sectionId;
    stickies.forEach(function (st) {
      if (st.root.getAttribute('data-section-id') === id) { st.forced = on; st.render(); }
    });
  }
  document.addEventListener('shopify:section:select', function (e) { setForced(e, true); });
  document.addEventListener('shopify:section:deselect', function (e) { setForced(e, false); });
})();
